import gallery06 from '../assets/gallery06.webp';
import gallery08 from '../assets/gallery08.webp';
import gallery01 from '../assets/gallery01.webp';
import gallery06Mobile from '../assets/gallery06-mobile.webp';
import gallery08Mobile from '../assets/gallery08-mobile.webp';
import gallery01Mobile from '../assets/gallery01-mobile.webp';
import gallery02 from '../assets/gallery02.webp';
import quote from '../assets/quote.png';
import gericht from '../assets/gericht.png';
import quota from '../assets/quota.png';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  gallery02,
  gallery06Mobile,
  gallery08Mobile,
  gallery01Mobile,
  gallery06,
  gallery08,
  quote,
  gericht,
  quota,
  gallery01,
};
